import Footer from "../components/footer";
import Header from "../components/header"
import SideNav from "../components/sidenav"
import PageHeader from "../components/pageHeader";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Link , useNavigate} from "react-router-dom";

const Exhibition = () =>{

    const navigate = useNavigate();
    const [dataExhibition, setDataExhibition] = useState([]);

    // Function to Fetch data from API for dropdown
    const fetchData = async (url, setData) => {

        try {
            const response = await fetch(url);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }

    };

    useEffect(() => {
        fetchData('https://igapi.heuristticminds.com/api/ExhibitionList/Get-GetExhibitionListAll', setDataExhibition);

    }, [dataExhibition]);

    

    const columns = [
        {
            name: "Title",
            selector: row => row.exhibitionTitle,
            sortable: true,
            width: "300px",
            cell: row => (
                <div style={{ wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                    {row.exhibitionTitle}
                </div>
            )
        },
        /* {
            name: "Description",
            selector: row => row.description,
            cell: (row) => (
                <div style={{ whiteSpace: "pre-line", width: "1350px" }} dangerouslySetInnerHTML={{ __html: row.description }} />
            ),
            allowOverflow: true,
            maxWidth:"650px",
        }, */
        {
            name: "Date",
            selector: row => row.exhibitionDate,            
            allowOverflow: true,
            maxWidth:"200px",
        },
        {
            name: "Action",
            cell: (row) => (
                <div>
                    <Link to={``} onClick={() => onStatusClick(row.id)}>
                        <img
                            src={row.exhibitionStatus === 'Active' ? "/images/ImgActive.gif" : "/images/ImgInActive.gif"}
                            alt="Change Status"
                            title="Change Status"
                            style={{ width: "50px", height: "25px" }}
                        />
                    </Link>

                    {' '} {' '}{' '} {' '}{' '} {' '}{' '} {' '}
                    <Link to={`/addExhibition/`} onClick={(event) => onEditClick(event, row.id)}>
                        <img
                            src="/images/ImgEdit.ico" // Set the correct image source
                            alt="Edit"
                            title="Edit"
                            style={{ width: "30px", height: "30px" }}
                        />
                    </Link>
                    {' '} {' '}{' '} {' '}{' '} {' '}{' '} {' '}
                    <Link to={`/addExhibition/`} className="bi bi-images" onClick={(event) => onAddArtworkClick(event, row.id)}>
                       Add Artwork To Exhibition
                    </Link>
                    {' '} {' '}{' '} {' '}{' '} {' '}{' '} {' '}
                    <Link to={`/viewExhibition/`} className="bi bi-eye" onClick={(event) => onViewExhibitionClick(event, row.id)}>
                       View Exhibition
                    </Link>
                </div>
            ),
            maxWidth:"500px",

        },
    ];

    const onStatusClick = async (id) =>{
        
        const confirmed = window.confirm("Are you sure you want to change Exhibition status?");
        if (!confirmed) {
            return; // If not confirmed, return early without deleting
        }
        try {
            
            const response = await fetch('https://igapi.heuristticminds.com/api/ExhibitionList/Update-ChangeExhibitionStatus?id=' + id, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (response.ok) {
                fetchData('https://igapi.heuristticminds.com/api/ExhibitionList/Get-GetExhibitionListAll', setDataExhibition);
            }
        }
        catch {
        }

    }

    const onEditClick = async (event, id) => {

        event.preventDefault(); // Prevents the default behavior of the link
        navigate(`/addExhibition/${id}`);
        window.scrollTo({
            top: 0,
            behavior: "instant"
        });
    }

    const onAddArtworkClick = async (event, id)=> {

        event.preventDefault(); // Prevents the default behavior of the link
        navigate(`/addExhibitionArtwork/${id}`);
        window.scrollTo({
            top: 0,
            behavior: "instant"
        });
    }

    const onViewExhibitionClick = async (event, id)=> {

        event.preventDefault(); // Prevents the default behavior of the link
        navigate(`/viewExhibition/${id}`);
        window.scrollTo({
            top: 0,
            behavior: "instant"
        });
    }

    return(
        <>
        <Header />
        <div id="layoutSidenav">
                <SideNav />
                <div id="layoutSidenav_content">
                    <PageHeader name='Exhibition' icon='bi bi-activity' />
                    <div className="container-xl px-4">
                        <div className="row">
                            <div className="col-lg-12 mb-4">
                                <div className="card mb-4">
                                    <div className="card-header">Exhibition Details</div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <a href="/addExhibition" className="btn btn-primary"><i className="bi bi-plus-circle-fill"></i> Add Exhibition</a>
                                            </div>
                                        </div>
                                        <div className="pb-2">                                    
                                            <div className="ps-2 pe-2">
                                                <DataTable 
                                                    columns={columns}
                                                    data={dataExhibition}
                                                /> 
                                            </div>   
                                        </div>
                                    </div>
                                </div>
                            </div>                    
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    );
};
export default Exhibition;